import axios from 'axios'

export default {
    getLanguages: async function(){
        let languages = (await axios.get('/api/languages/list')).data
        return languages    
    },
    
}